export const allowedMimeTypes = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "video/mp4", // MP4 format
  "video/webm", // WebM format
  "video/quicktime", // MOV format
  "video/x-matroska", // MKV format
  "video/ogg", // OGV format
  "application/pdf", // PDF
  "application/msword", // DOC (legacy)
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
];
